import { render } from "./GameStockEditor.vue?vue&type=template&id=54090b73&scoped=true"
import script from "./GameStockEditor.vue?vue&type=script&lang=ts"
export * from "./GameStockEditor.vue?vue&type=script&lang=ts"

import "./GameStockEditor.vue?vue&type=style&index=0&id=54090b73&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-54090b73"

export default script